var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "customProjectTasks" },
    [
      _c("div", { staticClass: "flex w-auto w-full flex-col containerTop" }, [
        _c("div", { staticClass: "flex items-start justify-start mb-3" }, [
          _c(
            "span",
            {
              staticClass:
                "inline-flex items-center justify-center rounded-md border px-2 py-0.5 text-xs font-medium w-fit whitespace-nowrap shrink-0",
              class: _vm.statusBadgeClasses,
            },
            [_vm._v(" " + _vm._s(_vm.statusText) + " ")]
          ),
        ]),
        _c(
          "div",
          { staticClass: "client-info-section mb-4 p-3 rounded-lg bg-gray-50" },
          [
            _c(
              "h3",
              {
                staticClass:
                  "text-lg font-semibold text-blue-600 mb-2 cursor-pointer hover:underline",
                on: { click: _vm.navigateToClient },
              },
              [_vm._v(" " + _vm._s(_vm.clientName) + " ")]
            ),
            _c("p", { staticClass: "text-sm text-gray-600" }, [
              _vm._v(
                " " +
                  _vm._s(_vm.clientAge) +
                  " | " +
                  _vm._s(_vm.clientGender) +
                  " "
              ),
            ]),
          ]
        ),
        _c("div", { staticClass: "flex flex-col gap-3.5 mb-3" }, [
          _c("div", { staticClass: "flex flex-row adjustItems" }, [
            _vm.activity.virtual && _vm.activity.virtual_meeting_link
              ? _c(
                  "a",
                  {
                    staticClass:
                      "text-blue text-sm font-400 hover:underline inline-flex items-center gap-1",
                    attrs: {
                      href: _vm.activity.virtual_meeting_link,
                      target: "_blank",
                      rel: "noopener noreferrer",
                    },
                  },
                  [
                    _c(
                      "svg",
                      {
                        attrs: {
                          xmlns: "http://www.w3.org/2000/svg",
                          width: "14",
                          height: "14",
                          viewBox: "0 0 24 24",
                          fill: "none",
                          stroke: "currentColor",
                          "stroke-width": "2",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                        },
                      },
                      [
                        _c("rect", {
                          attrs: {
                            x: "2",
                            y: "7",
                            width: "20",
                            height: "15",
                            rx: "2",
                            ry: "2",
                          },
                        }),
                        _c("polyline", { attrs: { points: "22,7 12,13 2,7" } }),
                      ]
                    ),
                    _vm._v(" Join Virtual Meeting "),
                  ]
                )
              : _vm.location
              ? _c(
                  "a",
                  {
                    staticClass: "text-blue text-sm font-400 hover:underline",
                    attrs: {
                      href: _vm.googleMapsLink,
                      target: "_blank",
                      rel: "noopener noreferrer",
                    },
                  },
                  [_vm._v(" " + _vm._s(_vm.location) + " ")]
                )
              : _c("p", { staticClass: "text-blue text-sm font-400" }, [
                  _vm._v("n/a"),
                ]),
          ]),
          _vm.activity.virtual && _vm.activity.fallback_num
            ? _c(
                "div",
                {
                  staticClass: "flex items-center gap-1 text-gray-600 text-sm",
                },
                [
                  _c(
                    "svg",
                    {
                      staticClass: "w-4 h-4",
                      attrs: {
                        xmlns: "http://www.w3.org/2000/svg",
                        width: "14",
                        height: "14",
                        viewBox: "0 0 24 24",
                        fill: "none",
                        stroke: "currentColor",
                        "stroke-width": "2",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                      },
                    },
                    [
                      _c("path", {
                        attrs: {
                          d: "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z",
                        },
                      }),
                    ]
                  ),
                  _c("span", [_vm._v(_vm._s(_vm.activity.fallback_num))]),
                ]
              )
            : _vm._e(),
        ]),
        _c("div", { staticClass: "flex flex-col gap-2 mb-3" }, [
          _c(
            "div",
            { staticClass: "flex" },
            [
              _c("CalendarIcon", { staticClass: "h-5 w-5" }),
              _c("p", { staticClass: "projectInfo ml-2" }, [
                _vm._v(_vm._s(_vm.formattedDate)),
              ]),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "flex" },
            [
              _c("LocationIcon", { staticClass: "h-5 w-5" }),
              _c("p", { staticClass: "projectInfo ml-2" }, [
                _vm._v(_vm._s(_vm.timeRange)),
              ]),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "flex mb-3" },
            [
              _c("StarIcon", { staticClass: "h-5 w-5" }),
              _c("p", { staticClass: "projectInfo ml-2" }, [
                _vm._v("Type of activity: " + _vm._s(_vm.typeOfVisit)),
              ]),
            ],
            1
          ),
        ]),
        _c(
          "div",
          { staticClass: "clock-section mb-4 p-3 bg-gray-50 rounded-lg" },
          [
            _c("div", { staticClass: "grid grid-cols-2 gap-4" }, [
              _c("div", { staticClass: "text-center" }, [
                _c(
                  "div",
                  {
                    staticClass: "flex items-center justify-center gap-1 mb-1",
                  },
                  [
                    _c("ClockIcon", { staticClass: "h-3 w-3 text-gray-500" }),
                    _c("span", { staticClass: "text-xs text-gray-500" }, [
                      _vm._v("Clock In"),
                    ]),
                  ],
                  1
                ),
                _c("p", { staticClass: "projectInfo text-sm mb-1" }, [
                  _vm._v(_vm._s(_vm.checkinTimeFormatted)),
                ]),
                _vm.checkinStatus
                  ? _c(
                      "span",
                      {
                        staticClass:
                          "inline-flex items-center justify-center rounded-md border px-1.5 py-0.5 text-xs font-medium",
                        class: _vm.getStatusChipClasses(_vm.checkinStatus),
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm.formatStatusText(_vm.checkinStatus)) +
                            " "
                        ),
                      ]
                    )
                  : _vm._e(),
              ]),
              _c("div", { staticClass: "text-center" }, [
                _c(
                  "div",
                  {
                    staticClass: "flex items-center justify-center gap-1 mb-1",
                  },
                  [
                    _c("ClockIcon", { staticClass: "h-3 w-3 text-gray-500" }),
                    _c("span", { staticClass: "text-xs text-gray-500" }, [
                      _vm._v("Clock Out"),
                    ]),
                  ],
                  1
                ),
                _c("p", { staticClass: "projectInfo text-sm mb-1" }, [
                  _vm._v(_vm._s(_vm.checkoutTimeFormatted)),
                ]),
                _vm.checkoutStatus
                  ? _c(
                      "span",
                      {
                        staticClass:
                          "inline-flex items-center justify-center rounded-md border px-1.5 py-0.5 text-xs font-medium",
                        class: _vm.getStatusChipClasses(_vm.checkoutStatus),
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm.formatStatusText(_vm.checkoutStatus)) +
                            " "
                        ),
                      ]
                    )
                  : _vm._e(),
              ]),
            ]),
          ]
        ),
        _c(
          "div",
          { staticClass: "flex flex-col justify-center gap-3 mb-4" },
          [
            _c("UIButton", {
              attrs: {
                buttonText: "View Notes",
                variant: "outline-black",
                size: "lg",
                fullWidth: true,
              },
              on: { click: _vm.handleViewNotes },
              scopedSlots: _vm._u([
                {
                  key: "icon",
                  fn: function () {
                    return [_c("NotesView", { staticClass: "w-4 h-4" })]
                  },
                  proxy: true,
                },
                {
                  key: "hover-icon",
                  fn: function () {
                    return [_c("NotesView", { staticClass: "w-4 h-4" })]
                  },
                  proxy: true,
                },
              ]),
            }),
          ],
          1
        ),
        _c("div", { staticClass: "flex items-center gap-2 mb-3" }, [
          _c("span", { staticClass: "text-sm text-gray-600" }, [
            _vm._v("Assignee:"),
          ]),
          _c(
            "span",
            {
              staticClass:
                "inline-flex items-center justify-center rounded-md border px-2 py-0.5 text-xs font-medium w-fit whitespace-nowrap bg-white text-gray-800 border-gray-300 cursor-pointer hover:bg-gray-50 transition-colors",
              on: { click: _vm.navigateToContractor },
            },
            [
              _vm.assigneeName
                ? _c(
                    "span",
                    {
                      staticClass:
                        "relative flex size-10 shrink-0 overflow-hidden rounded-full h-4 w-4 mr-2",
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass:
                            "flex size-full items-center justify-center rounded-full bg-purple-500 text-white text-xs",
                        },
                        [_vm._v(" " + _vm._s(_vm.assigneeInitials) + " ")]
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" " + _vm._s(_vm.assigneeName || "n/a") + " "),
            ]
          ),
        ]),
      ]),
      _vm.showNotesModal
        ? _c("NotesModal", {
            attrs: {
              currentUser: _vm.currentUser,
              activity: _vm.activity,
              project: _vm.project,
            },
            on: {
              close: function ($event) {
                _vm.showNotesModal = false
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }